import { useQuery } from "@tanstack/react-query";
import type { DiarioDetalhe, DiarioResumo, UsuarioResumo } from "../../../shared/diario";
import { api } from "./cliente";

export const useUsuariosLista = () =>
  useQuery({ queryKey: ["usuarios-lista"], queryFn: () => api<UsuarioResumo[]>("/api/usuarios/lista"), staleTime: 5 * 60 * 1000 });

export const chavesDiario = {
  lista: ["diarios"] as const,
  item: (id: number) => ["diario", id] as const,
};

export const useDiarios = () =>
  useQuery({ queryKey: chavesDiario.lista, queryFn: () => api<DiarioResumo[]>("/api/diarios") });

export const useDiario = (id: number) =>
  useQuery({
    queryKey: chavesDiario.item(id),
    queryFn: () => api<DiarioDetalhe>(`/api/diarios/${id}`),
    enabled: Number.isInteger(id) && id > 0,
  });
